<!--
	TEMPLATE
-->
<template>
<div class="editable-input">
	<div v-if="!isEditView">{{ input }}</div>

	<div v-if="isEditView">
		<input-with-clear v-model="input" :placeholder="options.placeholder" :class="{ 'editable-item__required': hasErrors }"></input-with-clear>
	</div>
</div>
</template>

<!--
	SCRIPT
-->
<script>
import vModelNested from '@/libs/vModelNested.js';
import InputWithClear from '../InputWithClear.vue';

export default {
	props: {
		value: String,
		options: Object,
		isEditView: Boolean
	},
	data: function() {
		return {
			hasErrors: false
		}
	},
	components: {
		'input-with-clear': InputWithClear
	},
	watch: {
		input: function() {
			this.hasErrors = this.input == ''
			this.$emit('hasErrors', this.hasErrors)
		}
	},
	computed: {
		input: vModelNested
	}
}
</script>



// WEBPACK FOOTER //
// src/components/editable-items/EditableInput.vue